import { Component, computed, inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrButton } from '@govbr-ds/webcomponents-angular/standalone';

/**
 * Aviso de expiração de sessão (SIMRAD-145).
 * Só conta o tempo e devolve a escolha do usuário — quem decide o que fazer
 * com a sessão é o SessionManagerService.
 */
@Component({
  selector: 'app-session-expiry-modal',
  imports: [BrButton],
  templateUrl: './session-expiry-modal.component.html',
  styleUrl: './session-expiry-modal.component.scss',
})
export class SessionExpiryModalComponent implements OnInit, OnDestroy {
  /** Instante (epoch ms) em que a sessão expira. */
  @Input({ required: true }) expiraEm!: number;

  private readonly activeModal = inject(NgbActiveModal);

  // Zoneless: signal para que o setInterval redesenhe a contagem sem ChangeDetectorRef.
  private readonly segundosRestantes = signal(0);

  protected readonly rotuloContagem = computed(() => {
    const total = this.segundosRestantes();
    const minutos = Math.floor(total / 60);
    const segundos = total % 60;
    return `${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;
  });

  private intervalo: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.atualizarContagem();
    this.intervalo = setInterval(() => this.atualizarContagem(), 1_000);
  }

  ngOnDestroy(): void {
    if (this.intervalo !== null) {
      clearInterval(this.intervalo);
      this.intervalo = null;
    }
  }

  continuar(): void {
    this.activeModal.close('renovar');
  }

  sair(): void {
    this.activeModal.close('sair');
  }

  private atualizarContagem(): void {
    const restante = Math.max(0, Math.ceil((this.expiraEm - Date.now()) / 1_000));
    this.segundosRestantes.set(restante);
    if (restante === 0) {
      if (this.intervalo !== null) {
        clearInterval(this.intervalo);
        this.intervalo = null;
      }
      this.activeModal.close('expirado');
    }
  }
}
